import { defineComponent as r, createBlock as n, openBlock as a, unref as p, mergeProps as l, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as f } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconArrowLeft",
  __name: "IconArrowLeft",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, e) => (a(), n(p(f), l(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", { d: "M8.427 7.53a.75.75 0 0 0-1.06-1.06L2.72 11.116a1.25 1.25 0 0 0 0 1.768l4.646 4.646a.75.75 0 0 0 1.06-1.06l-3.719-3.72h16.19a.75.75 0 0 0 0-1.5H4.706l3.72-3.72" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
